import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { apiLink } from "../../../constant/api-link";
import { LocalStorageService } from "angular-2-local-storage";
import { CreateVoucherPackageModel, UpdateVoucherPackageModel, VoucherPackageListModel, VoucherPackageListQueryModel } from "../../../model/builk/voucher/voucher-list.model";

@Injectable({
    providedIn: "root"
})
export class VoucherService {

    constructor(
        private http: HttpClient,
        private localStorageService: LocalStorageService
    ) { }

    sub: any;

    getVoucher(query: VoucherPackageListQueryModel): Observable<VoucherPackageListModel> {
        const url = apiLink.getVoucherPackageList;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });
        let params = new HttpParams()
        .set("PageNumber", query.pageNumber.toString())
        .set("PageSize", query.pageSize.toString())
        .set("SortByDesc", query.sortByDesc.toString())
        .set("SortColumn", query.sortColumn.toString());

        if (query.textSearch !== undefined && query.textSearch !== null && query.textSearch !== '') {
          params = params.append("TextSearch", query.textSearch.toString());
        }
        return this.http.get<VoucherPackageListModel>(url, { headers: headers,params: params });
    }

    createVoucherPackage(model: CreateVoucherPackageModel): Observable<boolean> {
        const url = apiLink.createVoucherPackage;
        let form = new FormData();
        form.append('voucherHeader', model.voucherHeader);
        form.append('voucherDetail', model.voucherDetail);
        form.append('file', model.file);
        form.append('voucherSalePrice', model.voucherSalePrice.toString());
        form.append('voucherRedeemPrice', model.voucherRedeemPrice.toString());
        form.append('product', model.product);
        form.append('descriptionUrl', model.descriptionUrl);
        form.append('userSurrKey', this.localStorageService.get("userSurrKey"));
        return this.http.post<boolean>(url, form);
    }

    updateVoucherPackage(model: UpdateVoucherPackageModel): Observable<boolean> {
      const url = apiLink.updateVoucherPackage;
      let form = new FormData();
      form.append('voucherPackageSurrKey', model.voucherPackageSurrKey.toString());
      form.append('voucherHeader', model.voucherHeader);
      form.append('voucherDetail', model.voucherDetail);
      form.append('file', model.file);
      form.append('voucherSalePrice', model.voucherSalePrice.toString());
      form.append('voucherRedeemPrice', model.voucherRedeemPrice.toString());
      form.append('product', model.product);
      if (model.descriptionUrl !== undefined && model.descriptionUrl !== null && model.descriptionUrl !== '') {
        form.append('descriptionUrl', model.descriptionUrl);
      } else {
        form.append('descriptionUrl', null);
      }
      form.append('userSurrKey', this.localStorageService.get("userSurrKey"));
      if (model.isActive !== undefined && model.isActive !== null) {
        form.append('isActive', model.isActive.toString());
      }
      return this.http.put<boolean>(url, form);
  }
}
